import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type WebSettingsIntegrationsQueryQueryVariables = Types.Exact<{ [key: string]: never }>;

export type WebSettingsIntegrationsQueryQuery = {
  __typename: "Query";
  viewer: {
    __typename: "Viewer";
    user: {
      __typename: "User";
      orgs: {
        __typename: "OrgConnection";
        edges: Array<{
          __typename: "OrgEdge";
          node: {
            __typename: "Org";
            id: string;
            name: string | null;
            experiments: Array<string | null> | null;
            primaryOrgCalendar: string;
            slackAccountsErrorable:
              | {
                  __typename: "GraphEntityError";
                  message: string | null;
                  statusCode: number | null;
                }
              | {
                  __typename: "SlackAccountList";
                  list: Array<{
                    __typename: "SlackAccount";
                    id: string;
                    slackTeamId: string | null;
                    slackUserId: string | null;
                    teamDisplayName: string | null;
                    needsUpdate: boolean;
                  }>;
                };
            slackSettingsErrorable:
              | {
                  __typename: "GraphEntityError";
                  statusCode: number | null;
                  message: string | null;
                }
              | {
                  __typename: "SlackSettingsList";
                  list: Array<{
                    __typename: "SlackSettings";
                    id: string;
                    slackTeamId: string;
                    slackUserId: string;
                    calendarStatusEnabled: boolean;
                    includeMeetingCategory: boolean;
                    includeMeetingTitle: boolean;
                    calendarStatus: {
                      __typename: "SlackCalendarStatusSync";
                      calendarStatusEnabled: boolean;
                      includeMeetingCategory: boolean;
                      includeMeetingTitle: boolean;
                    } | null;
                    dailyDigestSettings: {
                      __typename: "SlackDailyDigestSettings";
                      enabled: boolean;
                      timeSlot: Types.DigestTimeSlot;
                    } | null;
                    dndSettings: {
                      __typename: "SlackDndSettings";
                      focusTime: boolean;
                      meeting: boolean;
                    } | null;
                    notificationSettings: {
                      __typename: "SlackNotificationSettings";
                      defragSummary: boolean;
                    } | null;
                  }>;
                };
            zoomUserLevelAccount:
              | {
                  __typename: "GraphEntityError";
                  message: string | null;
                  statusCode: number | null;
                }
              | {
                  __typename: "ZoomAccount";
                  accountId: string;
                  connected: string;
                  displayName: string;
                  ownerUserId: string;
                  ownerPersons:
                    | {
                        __typename: "GraphEntityError";
                        message: string | null;
                        statusCode: number | null;
                      }
                    | {
                        __typename: "PersonList";
                        list: Array<{
                          __typename: "Person";
                          primaryEmail: string;
                          isYou: boolean;
                          profile: {
                            __typename: "UserProfile";
                            givenName: string | null;
                            familyName: string | null;
                            externalImageUrl: string | null;
                          } | null;
                        }>;
                      };
                }
              | null;
            zoomAccount:
              | {
                  __typename: "GraphEntityError";
                  message: string | null;
                  statusCode: number | null;
                }
              | {
                  __typename: "ZoomAccount";
                  accountId: string;
                  connected: string;
                  displayName: string;
                  ownerUserId: string;
                  hasValidZoomAccount: boolean;
                }
              | null;
            asanaAccountErrorable:
              | { __typename: "AsanaAccount"; hasAsanaCredentials: boolean }
              | {
                  __typename: "GraphEntityError";
                  message: string | null;
                  statusCode: number | null;
                };
          } | null;
        } | null> | null;
      };
    } | null;
  };
};

export const WebSettingsIntegrationsQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WebSettingsIntegrationsQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orgs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "experiments" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slackAccountsErrorable" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "SlackAccountList" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "list" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "id" },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slackTeamId",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slackUserId",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "teamDisplayName",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "needsUpdate",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "GraphEntityError" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "message" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "statusCode" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slackSettingsErrorable" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "SlackSettingsList",
                                                  },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "list" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "id" },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slackTeamId",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slackUserId",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "calendarStatus",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "calendarStatusEnabled",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "includeMeetingCategory",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "includeMeetingTitle",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "dailyDigestSettings",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "enabled",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "timeSlot",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "dndSettings",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "focusTime",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "meeting",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "notificationSettings",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "defragSummary",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "calendarStatusEnabled",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "includeMeetingCategory",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "includeMeetingTitle",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "GraphEntityError" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "statusCode" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "message" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "primaryOrgCalendar" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "zoomUserLevelAccount" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "GraphEntityError" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "message" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "statusCode" },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "ZoomAccount" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "accountId" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "connected" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "displayName" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "ownerUserId" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "ownerPersons" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "__typename",
                                                            },
                                                          },
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value: "GraphEntityError",
                                                              },
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "message",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "statusCode",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value: "PersonList",
                                                              },
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "list",
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "primaryEmail",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "isYou",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "profile",
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "givenName",
                                                                              },
                                                                            },
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "familyName",
                                                                              },
                                                                            },
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value:
                                                                                  "externalImageUrl",
                                                                              },
                                                                            },
                                                                          ],
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "zoomAccount" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "GraphEntityError" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "message" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "statusCode" },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "ZoomAccount" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "accountId" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "connected" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "displayName" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "ownerUserId" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "hasValidZoomAccount",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "asanaAccountErrorable" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "AsanaAccount" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "hasAsanaCredentials",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "GraphEntityError" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "message" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "statusCode" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  WebSettingsIntegrationsQueryQuery,
  WebSettingsIntegrationsQueryQueryVariables
>;
